import React from 'react'
import PageHeader from '../components/PageHeader'

function AcademicCalendar() {
  return (
    <div>  
      <PageHeader title="Academic Calendar" />
    </div>
  )
}

export default AcademicCalendar
